export enum OrderType {
    Manual = 'TYPE_MANUAL',
    Shop = 'TYPE_SHOP',
    Anonymous = 'TYPE_ANONYMOUS',
    SingleInquiry = 'TYPE_SINGLE_INQUIRY',
}

const translationObject: { [Key in OrderType]: string } = {
    [OrderType.Manual]: 'app.orderType.manual',
    [OrderType.Shop]: 'app.orderType.shop',
    [OrderType.Anonymous]: 'app.orderType.anonymous',
    [OrderType.SingleInquiry]: 'app.orderType.singleinquiry',
};

export const getOrderTypeTranslationId = (status: OrderType): string => {
    return translationObject[status];
};
